import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { getdata, getdatanoauth, updatedata, deletedata } from "../../util/global";
import { product, subscription, subscriptiondef, locationitem } from './Datatype';

interface cartitem {
  productid: string;
  name: string;
  price: number | string;
  quantity: number;
}

const frequencies = [
  // { value: 'daily', label: 'Daily', text: 'every day' },
  // { value: 'alternate', label: 'Alternate days', text: 'every other day' },
  { value: 'weekly', label: 'Weekly', text: 'every week' },
  // { value: 'biweekly', label: 'Bi-weekly', text: 'every 2 weeks' }
];

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const durations = [
  { value: '1month', label: '1 Month', text: '1 month' },
  { value: '3months', label: '3 Months', text: '3 months' },
  { value: '1year', label: '1 Year', text: '1 year' }
];

const labels = ['Home', 'Office', 'Other'];

const durationdiscounts: Record<string, number> = { "1month": 0, "3months": 0, "1year": 0 };
// percent off recurring, rates pending confirmation from Veen

// all pill groups now share the .pill class from css/reveen/style.css
// const pill = (selected: boolean): React.CSSProperties => ({
//   padding: '8px 16px',
//   borderRadius: '999px',
//   fontSize: '0.85rem',
//   fontFamily: 'var(--sans)',
//   cursor: 'pointer',
//   border: '1px solid var(--terra)',
//   background: selected ? 'var(--terra)' : 'transparent',
//   color: selected ? '#ffffff' : 'var(--terra)'
// });

const muted: React.CSSProperties = { fontSize: '0.8rem', color: 'var(--muted)' };
const row: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

const Subscribe = () => {
  const navigate = useNavigate();
  const [searchparams] = useSearchParams();
  const id = searchparams.get('id');
  const [items, setitems] = useState<cartitem[]>([]);
  const [products, setproducts] = useState<product[]>([]);
  const [cartid, setcartid] = useState<string | null>(null);
  const [frequency, setfrequency] = useState('weekly');
  const [preferredday, setpreferredday] = useState('Mon');
  const [duration, setduration] = useState('1month');
  const [subscriptionid, setsubscriptionid] = useState<string | null>(null);
  const [status, setstatus] = useState('pending');
  const [label, setlabel] = useState('Home');
  const [name, setname] = useState(window.APPUSER.user.name || '');
  const [phone, setphone] = useState(window.APPUSER.user.phone || '');
  const [address, setaddress] = useState('');
  const [pin, setpin] = useState('');
  // '' not checked yet, 'ok' we deliver to the pin, 'no' we do not
  const [pinstatus, setpinstatus] = useState<'' | 'ok' | 'no'>('');
  const [message, setmessage] = useState('');
  // busy disables the save button while the subscription is saved and payment is started
  const [busy, setbusy] = useState(false);
  const [loaded, setloaded] = useState(false);
  const [subcount, setsubcount] = useState(0);
  const [position, setposition] = useState(0);

  const fetchsubs = async () => {
    const subs = await getdata({ filter: { datatype: "subscriptiondata" } });
    setsubcount(subs.length);
    const sorted = [...subs].sort((a, b) => a._id.localeCompare(b._id));
    setposition(sorted.findIndex((s) => s._id === id) + 1);
  };

  const fetchcart = async () => {
    const dbcart = await getdata({ filter: { datatype: "cartdata", userid: window.APPUSER.user.userid } });
    if (dbcart.length > 0) {
      setcartid(dbcart[0]._id);
      setitems(dbcart[0].items);
      setfrequency(frequencies.find((f) => f.value === dbcart[0].frequency) ? dbcart[0].frequency : 'weekly');
      setpreferredday(dbcart[0].preferredday || 'Mon');
      setduration(dbcart[0].duration || '1month');
    }
    const res = await getdatanoauth({ filter: { datatype: "productdata" } });
    setproducts(res);
    setloaded(true);
  };

  const fetchsubscription = async () => {
    const record = await getdata({ filter: { datatype: "subscriptiondata", _id: id } });
    const sub = record[0];
    setsubscriptionid(sub._id);
    setitems(sub.items);
    setfrequency(frequencies.find((f) => f.value === sub.frequency) ? sub.frequency : 'weekly');
    setpreferredday(sub.preferredday || 'Mon');
    setduration(sub.duration || '1month');
    setlabel(sub.label || 'Home');
    setname(sub.name);
    setphone(sub.phone);
    setaddress(sub.address);
    setpin(sub.pin);
    checkpin(sub.pin);
    setstatus(sub.status);
    const res = await getdatanoauth({ filter: { datatype: "productdata" } });
    setproducts(res);
    setloaded(true);
  };

  // serviceability check, same rule as Home: the pin must be listed in an open location.
  // the result is stored for the hint under the field and returned so a save can await a fresh answer
  const checkpin = async (value: string): Promise<'' | 'ok' | 'no'> => {
    if (value.length < 6) {
      setpinstatus('');
      return '';
    }
    const zones = await getdatanoauth({ filter: { datatype: "locationdata" } });
    const zone = zones.find((z: locationitem) =>
      z.status === 'open' && z.pins.split(',').map(p => p.trim()).includes(value)
    );
    const result = zone ? 'ok' : 'no';
    setpinstatus(result);
    return result;
  };

  // cartdata is only kept in sync while building a new subscription
  const save = async (cart: cartitem[], freq: string, day: string, dur: string) => {
    if (id) return;
    localStorage.setItem("cart", JSON.stringify(cart));
    await updatedata({
      data: {
        _id: cartid,
        datatype: "cartdata",
        userid: window.APPUSER.user.userid,
        items: cart,
        frequency: freq,
        preferredday: day,
        duration: dur
      }
    });
  };

  const changefrequency = (value: string) => {
    setfrequency(value);
    save(items, value, preferredday, duration);
  };

  const changeday = (value: string) => {
    setpreferredday(value);
    save(items, frequency, value, duration);
  };

  const changeduration = (value: string) => {
    setduration(value);
    save(items, frequency, preferredday, value);
  };

  const updatequantity = (productid: string, delta: number) => {
    const updated = items
      .map((item) => item.productid === productid ? { ...item, quantity: item.quantity + delta } : item)
      .filter((item) => item.quantity > 0);
    setitems(updated);
    save(updated, frequency, preferredday, duration);
  };

  // saves the subscription; a pending one then goes straight to payment, same flow as startautopay in Checkout
  const savesubscription = async () => {
    if (!name || !phone || !address || !pin) {
      setmessage('Please fill in name, phone, address and pin code');
      return;
    }
    // a pin typed just before clicking save may not have been checked yet, so check it here instead of trusting blur timing
    const pinresult = pinstatus === 'ok' ? 'ok' : await checkpin(pin);
    if (pinresult !== 'ok') {
      setmessage('Please enter a pin code we deliver to');
      setbusy(false);
      return;
    }
    const record: subscription = {
      ...subscriptiondef,
      _id: subscriptionid,
      label,
      name,
      phone,
      address,
      pin,
      items,
      frequency,
      preferredday,
      duration,
      itemstotal,
      deposittotal,
      discount,
      status
    };
    setbusy(true);
    setmessage('');
    // a new record gets its id from the api response, an edited one already has it
    const res = await updatedata({ data: record });
    const savedid = subscriptionid || res[0].id;
    if (!id) {
      await deletedata({ filter: { datatype: "cartdata" } });
      localStorage.removeItem("cart");
    }

    // an active or paused subscription is already paid for, so editing it only saves
    if (status !== 'pending') {
      navigate('/subscriptions');
      return;
    }

    // payment now starts from the checkout page
    // const pay = await getdata({ id: savedid }, '/createmandate');
    // if (!pay || pay.error) {
    //   setbusy(false);
    //   setmessage(pay?.error || 'Saved, but payment could not be started. Open it from My Subscriptions to try again.');
    //   return;
    // }
    // const total = Number(pay.monthly || 0) + Number(pay.deposit || 0);
    // window.location.href = '/dummygateway?order_id=' + encodeURIComponent(pay.order_id) + '&subscriptionid=' + encodeURIComponent(pay.subscriptionid) + '&amount=' + encodeURIComponent(total);
    navigate('/checkout/' + savedid);
  };

  useEffect(() => {
    id ? fetchsubscription() : fetchcart();
    fetchsubs();
  }, []);

  const depositof = (productid: string) =>
    Number(products.find((p) => p._id === productid)?.deposit) || 0;

  const itemstotal = items.reduce((sum, item) => sum + (Number(item.price) || 0) * item.quantity, 0);
  const deposittotal = items.reduce((sum, item) => sum + depositof(item.productid) * item.quantity, 0);
  const frequencytext = frequencies.find((f) => f.value === frequency)!.text;
  const durationtext = durations.find((d) => d.value === duration)!.text;
  const discountrate = durationdiscounts[duration];
  const discount = itemstotal * discountrate / 100;

  if (!loaded) return null;

  if (items.length === 0) {
    return (
      <div className="content-area" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', textAlign: 'center' }}>
        <p style={{ margin: '40px 0 16px' }}>No products in your subscription yet</p>
        <Link to="/shop">Browse products</Link>
      </div>
    );
  }

  return (
    // paddingBottom keeps the pin code field clear of the bottom bar; overflowY visible lets the
    // summary card stick to the window, .content-area's own overflow would stop it from sticking
    <div className="content-area" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', paddingBottom: '96px', overflowY: 'visible' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>

        <div>
          <div className="eyebrow">STEP 03</div>
          <h2 style={{ fontFamily: 'var(--display)', fontSize: '1.9rem', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 24px' }}>{id ? 'Edit your subscription.' : 'Build your subscription(s).'}</h2>
          <div className="sub-count">
            {id ? `Subscription #${position} · ${label}` : `This will be subscription #${subcount + 1}. You can have as many as you need, one per address.`}
          </div>

          {/* deliveries are weekly only for now, so the frequency choice is hidden */}
          {/* <div className="section">
            <div className="eyebrow">FREQUENCY</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {frequencies.map((f) => (
                <button type="button" key={f.value} className={frequency === f.value ? 'pill active' : 'pill'} onClick={() => changefrequency(f.value)}>
                  {f.label}
                </button>
              ))}
            </div>
          </div> */}

          <div className="section">
            <div className="eyebrow">QUANTITY PER DELIVERY</div>
            {items.map((item) => (
              <div key={item.productid} style={{ ...row, padding: '10px 0', borderBottom: '1px solid var(--rule-soft)' }}>
                <strong>{item.name}</strong>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <button type="button" className="btn-small" onClick={() => updatequantity(item.productid, -1)}>-</button>
                  <span>{item.quantity}</span>
                  <button type="button" className="btn-small" onClick={() => updatequantity(item.productid, 1)}>+</button>
                </div>
              </div>
            ))}
          </div>

          <div className="section">
            <div className="eyebrow">PREFERRED DELIVERY DAY</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {days.map((d) => (
                <button type="button" key={d} className={preferredday === d ? 'pill active' : 'pill'} onClick={() => changeday(d)}>
                  {d}
                </button>
              ))}
            </div>
          </div>

          <div className="section">
            <div className="eyebrow">PLAN DURATION</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {durations.map((d) => (
                <button type="button" key={d.value} className={duration === d.value ? 'pill active' : 'pill'} onClick={() => changeduration(d.value)}>
                  {d.label}
                </button>
              ))}
            </div>
          </div>

          <div className="section">
            <div className="eyebrow">DELIVER TO</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '14px' }}>
              {labels.map((l) => (
                <button type="button" key={l} className={label === l ? 'pill active' : 'pill'} onClick={() => setlabel(l)}>
                  {l}
                </button>
              ))}
            </div>
            <div className="fg">
              <label style={{ color: 'var(--cust-muted)' }}>Name</label>
              <input type="text" value={name} onChange={(e) => setname(e.target.value)} />
            </div>
            <div className="fg">
              <label style={{ color: 'var(--cust-muted)' }}>Phone</label>
              <input type="text" value={phone} onChange={(e) => setphone(e.target.value)} />
            </div>
            <div className="fg">
              <label style={{ color: 'var(--cust-muted)' }}>Address</label>
              <textarea rows={2} value={address} onChange={(e) => setaddress(e.target.value)} />
            </div>
            <div className="fg">
              <label style={{ color: 'var(--cust-muted)' }}>Pin Code</label>
              <input type="text" value={pin} onChange={(e) => setpin(e.target.value)} onBlur={(e) => checkpin(e.target.value)} />
              {pinstatus === 'ok' && <div style={muted}>We deliver here</div>}
              {pinstatus === 'no' && <div style={{ ...muted, color: '#B42318' }}>We are not in your area yet, coming soon</div>}
            </div>
          </div>
        </div>

        {/* stays in view on desktop while the left column scrolls; top clears the 64px fixed nav plus a 24px gap */}
        <div className="c-form" style={{ position: 'sticky', top: '88px', alignSelf: 'start' }}>
          <div className="eyebrow">ORDER SUMMARY</div>

          {items.map((item) => (
            <div key={item.productid} style={{ marginBottom: '14px' }}>
              <div style={row}>
                <strong>{item.name}</strong>
                <span>{item.quantity} x ₹{item.price}</span>
              </div>
              <div style={muted}>
                {item.quantity} x {item.name.toLowerCase()} · {frequencytext}, preferably {preferredday}
              </div>
            </div>
          ))}

          <div style={{ marginBottom: '14px' }}>
            <div style={row}>
              <span>One-time deposit</span>
              <span>₹{deposittotal}</span>
            </div>
            <div style={muted}>Fully refundable - returned when your jars come home.</div>
          </div>

          <hr style={{ border: 'none', borderTop: '1px solid var(--rule)', margin: '16px 0' }} />

          <div style={{ ...row, fontWeight: 600, marginBottom: '6px' }}>
            <span>First delivery</span>
            <span>₹{itemstotal + deposittotal}</span>
          </div>
          {discountrate > 0 && (
            <div style={{ ...row, marginBottom: '6px' }}>
              <span>Plan discount ({discountrate}%)</span>
              <span>-₹{discount}</span>
            </div>
          )}
          <div style={{ ...row, marginBottom: '6px' }}>
            <span>Then recurring</span>
            <span>₹{itemstotal - discount}</span>
          </div>
          <div style={{ ...muted, marginBottom: '20px' }}>{durationtext} plan · billed monthly</div>

          {/* the bottom bar is now the only save action, its button and the error message live there */}
          {/* <button type="button" className="btn-blue full-width" onClick={savesubscription} disabled={busy}>{busy ? 'Saving...' : status === 'pending' ? 'Save & checkout' : 'Save changes'}</button>
          {message && <div style={{ ...muted, color: 'var(--danger)', textAlign: 'center', marginTop: '8px' }}>{message}</div>} */}
        </div>

      </div>

      {/* always visible save bar, same pattern as the Shop page; this return only runs when there are items */}
      <div className="cartbar">
        <div className="cartbar-info">
          First payment <span>· ₹{itemstotal + deposittotal}</span>
        </div>
        {/* validation and payment errors show next to the button, where the user clicks */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {message && <div style={{ ...muted, color: '#B42318' }}>{message}</div>}
          <button type="button" className="btn-blue" onClick={savesubscription} disabled={busy}>
            {busy ? 'Saving...' : (status === 'pending' ? 'Save & checkout' : 'Save changes')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
